import React from "react";
import "../Footer/footer.css"
import { Col, Container, Row, ListGroup } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  const handleAboutClick = (e) => {
    if (location.pathname !== '/') {
      return; // Let the default navigation happen
    }
    
    e.preventDefault();
    const aboutSection = document.querySelector('.banner-description');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePackagesClick = (e) => {
    if (location.pathname !== '/') {
      return; // Let the default navigation happen
    }
    
    e.preventDefault();
    const packagesSection = document.getElementById('packages-section');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <footer className="pt-5">
        <Container>
          <Row>
            <Col md="3" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Company </h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/" onClick={handleAboutClick}>About Us</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/">Safari</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/">FAQs</NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md="3" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Explore </h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/"> FAQs</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/" onClick={handlePackagesClick}>Packages</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/"> Hotels</NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md="3" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Quick Link </h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/"> Home</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/" onClick={handleAboutClick}>About Us</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/contact"> Contact Us </NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md="3" sm="12" className="location mt-3 mt-md-0">
              <h4 className="mt-lg-0 mt-sm-3">Contact Info</h4>

              <div className="d-flex align-items-center">
                <i className="bi bi-geo-alt me-3"></i>
                <p className="pb-2">Ramnagar</p>
              </div>

              <div className="d-flex align-items-top my-2">
                <i className="bi bi-envelope me-3"></i>
                <a 
                  href="mailto:corbettaura15@gmail.com" 
                  className="d-block"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  corbettaura15@gmail.com
                </a>
              </div>

              <div className="d-flex align-items-top">
                <i className="bi bi-telephone me-3"></i>
                <a 
                  href="tel:+918979411128" 
                  className="d-block"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  +91 8979411128
                </a>
              </div>

              <div className="social-links mt-3">
                <a href="https://www.facebook.com/profile.php?id=61575604496984" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-facebook me-3"></i>
                </a>
                <a href="https://www.instagram.com/corbett_aura/" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-instagram me-3"></i>
                </a>
              </div>
            </Col>
          </Row>
          <Row className="py-2 bdr mt-3">
          <Col className="col copyright">
          <p className="text-light">© {new Date().getFullYear()} Corbett Aura. All rights reserved</p>
          </Col>
          </Row>

        </Container>
      </footer>
    </>
  );
};

export default Footer;
